<template>
  <div class="all-movies-area pb-100">
    <div class="container-fluid">
      <div class="mh-movies-title">
        <h5 class="text-white">أبرز الأحداث والمباريات القادمة حصرياً</h5>
      </div>
      <div class="all-movies-inner">
        <Swiper
          :spaceBetween="25"
          :loop="true"
          :autoplay="{
            delay: 5000,
            disableOnInteraction: false,
          }"
          :navigation="{
            prevEl: '.movies-button-prev',
            nextEl: '.movies-button-next',
          }"
          :breakpoints="{
            0: {
              slidesPerView: 1,
            },
            576: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            992: {
              slidesPerView: 3,
            },
            1200: {
              slidesPerView: 4,
            },
            1600: {
              slidesPerView: 5,
            },
          }"
          :modules="modules"
          class="all-movies-slider"
        >
          <SwiperSlide v-for="(movie, index) in movies" :key="index">
            <div class="all-movies-card">
              <div class="image">
                <img :src="movie.image" :alt="movie.title" />

                <lightgallery :settings="{ speed: 500, plugins }">
                  <a :href="movie.trailer" class="video-btn">
                    <i class="ri-play-fill"></i>
                  </a>
                </lightgallery>
              </div>
              <div class="content">
                <div class="top">
                  <!-- تحويل الزر إلى رابط واتساب مباشر بدون تنسيق داخلي -->
                  <a href="https://wa.me/447429916178" target="_blank" class="link-btn">
                    احجز تجربتك الآن
                    <i class="ri-add-line"></i>
                  </a>
                  <div class="share">
                    <i class="ri-share-fill"></i>
                    <ul class="list">
                      <li>
                        <a href="https://www.facebook.com/" target="_blank">
                          <i class="ri-facebook-fill"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://x.com/" target="_blank">
                          <i class="ri-twitter-x-line"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/" target="_blank">
                          <i class="ri-instagram-fill"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="title">
                  <h3>{{ movie.title }}</h3>
                  <span>الموعد: {{ movie.releaseDate }}</span>
                </div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>

        <div class="all-movies-button">
          <div class="movies-button-prev">
            <i class="ri-arrow-left-s-line"></i>
          </div>
          <div class="movies-button-next">
            <i class="ri-arrow-right-s-line"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay, Navigation } from "swiper/modules";

import Lightgallery from "lightgallery/vue";
import lgVideo from "lightgallery/plugins/video";

import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-video.css";

export default defineComponent({
  name: "UpcomingMovies",
  components: {
    Swiper,
    SwiperSlide,
    Lightgallery,
  },
  setup() {
    const plugins = ref([lgVideo]);

    const movies = ref([
      {
        image: require("@/assets/images/movie-home/movie7.jpg"),
        title: "نهائي دوري أبطال أوروبا بث مباشر",
        releaseDate: "قريباً على BEIN",
        trailer: "https://youtu.be/e1GrRouA5D8?si=S8NlTgzeW0HQ6m30",
      },
      {
        image: require("@/assets/images/movie-home/movie8.jpg"),
        title: "مباريات كأس العالم المباشرة والتصفيات",
        releaseDate: "تغطية شاملة 24/7",
        trailer: "https://youtu.be/e1GrRouA5D8?si=S8NlTgzeW0HQ6m30",
      },
      {
        image: require("@/assets/images/movie-home/movie9.jpg"),
        title: "إضافات حصرية لمكتبة أفلام مارفل الجديدة",
        releaseDate: "هذا الأسبوع بالترجمة",
        trailer: "https://youtu.be/e1GrRouA5D8?si=S8NlTgzeW0HQ6m30",
      },
      {
        image: require("@/assets/images/movie-home/movie10.jpg"),
        title: "عرض أقوى نزالات وجولات الـ UFC ومصارعة",
        releaseDate: "بث مباشر وحصري",
        trailer: "https://youtu.be/e1GrRouA5D8?si=S8NlTgzeW0HQ6m30",
      },
      {
        image: require("@/assets/images/movie-home/movie11.jpg"),
        title: "الموسم الجديد من المسلسلات الأكثر طلباً",
        releaseDate: "تحديث يومي تلقائي",
        trailer: "https://youtu.be/e1GrRouA5D8?si=S8NlTgzeW0HQ6m30",
      },
      {
        image: require("@/assets/images/movie-home/movie12.jpg"),
        title: "سباقات الفورمولا 1 ومهرجانات السرعة",
        releaseDate: "بجودة 4K فائقة",
        trailer: "https://youtu.be/e1GrRouA5D8?si=S8NlTgzeW0HQ6m30",
      },
    ]);

    return {
      modules: [Autoplay, Navigation],
      movies,
      plugins,
    };
  },
});
</script>